// Единицы измерения склада на стороне UI.
//
// Позиция учитывается в базовой единице (кг, л, шт), а повар в тех-карте думает
// граммами и миллилитрами. Раньше в поле расхода набивали «1» при цене 654 ₽/кг
// и получали фудкост в 3574% — цифра принималась молча.
//
// Здесь: канонический список для выбора и пара «базовая ↔ мелкая» для ввода.

export const CANONICAL_UNITS = ['кг', 'г', 'л', 'мл', 'шт', 'порция', 'упак'] as const;

/**
 * Мелкая единица для ввода расхода: `factor` — сколько её в одной базовой.
 * null — переключателя не будет (шт, порция и всё нестандартное).
 */
export function fineUnitFor(unit: string): { unit: string; factor: number } | null {
  switch (unit.trim().toLowerCase()) {
    case 'кг': return { unit: 'г', factor: 1000 };
    case 'л': return { unit: 'мл', factor: 1000 };
    default: return null;
  }
}

/**
 * Как показать количество в базовой единице человеку: 0.15 кг → «150 г».
 * Мелкую единицу используем, когда значение меньше единицы — так читается
 * привычнее, а «0.15» в отчёте выглядит как ошибка.
 */
export function formatQuantity(value: number, unit: string): string {
  const fine = fineUnitFor(unit);
  if (fine && value > 0 && value < 1) {
    return `${trimNumber(value * fine.factor)} ${fine.unit}`;
  }
  return `${trimNumber(value)} ${unit}`;
}

/** Число без хвоста нулей: 0.5 → «0,5», 150 → «150». */
export function trimNumber(value: number): string {
  const rounded = Math.round(value * 1000) / 1000;
  return rounded.toLocaleString('ru-RU', { maximumFractionDigits: 3 });
}
